<template>
  <apexchart type="radialBar" :height="height" :options="mergedOptions" :series="gaugeSeries" />
</template>

<script>
import { baseChartOptions, mergeOptions } from "./palette";

export default {
  name: "GaugeChart",
  props: {
    value: { type: Number, default: 0 },
    max: { type: Number, default: 100 },
    label: { type: String, default: "" },
    height: { type: [Number, String], default: 320 },
    id: { type: String, default: "gauge-chart" },
    // display the raw value (not percent) in the center
    showRawValue: { type: Boolean, default: true },
    options: { type: Object, default: () => ({}) },
  },
  computed: {
    gaugeSeries() {
      const pct = this.max ? (this.value / this.max) * 100 : 0;
      return [Number(pct.toFixed(1))];
    },
    mergedOptions() {
      const base = baseChartOptions(this.id);
      const raw = this.value;
      const showRaw = this.showRawValue;
      base.labels = [this.label];
      base.plotOptions = {
        radialBar: {
          hollow: { size: "62%" },
          track: { background: "#ECEFF1" },
          dataLabels: {
            name: { offsetY: 22, fontSize: "13px" },
            value: {
              offsetY: -8,
              fontSize: "30px",
              fontWeight: 700,
              formatter: (val) => (showRaw ? raw : `${val}%`),
            },
          },
        },
      };
      return mergeOptions(base, this.options);
    },
  },
};
</script>
